/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_S4_P1Inputs */

const en_guide_json_rest_api_s4_p1 = /** @type {(inputs: Guide_Json_Rest_Api_S4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API responses often come minified (no whitespace) to save bandwidth. To read them, paste the response into PureJSON's <a href="/">JSON Viewer</a> to get a formatted, navigable tree view. For TypeScript projects, use the <a href="/json-to-typescript">JSON to TypeScript</a> converter to generate type definitions from sample API responses.`)
};

const ko_guide_json_rest_api_s4_p1 = /** @type {(inputs: Guide_Json_Rest_Api_S4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 응답은 종종 대역폭을 절약하기 위해 압축(공백 없음)되어 옵니다. 이를 읽으려면 PureJSON의 <a href="/">JSON 뷰어</a>에 응답을 붙여넣어 포맷된 탐색 가능한 트리 뷰를 얻으세요. TypeScript 프로젝트의 경우 <a href="/json-to-typescript">JSON to TypeScript</a> 변환기로 샘플 API 응답에서 타입 정의를 생성하세요.`)
};

const ja_guide_json_rest_api_s4_p1 = /** @type {(inputs: Guide_Json_Rest_Api_S4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APIレスポンスは帯域幅を節約するために圧縮された状態（空白なし）で届くことが多いです。読みやすくするには、レスポンスをPureJSONの<a href="/">JSONビューアー</a>に貼り付けて、フォーマットされたツリービューを取得してください。TypeScriptプロジェクトでは、<a href="/json-to-typescript">JSON to TypeScript</a>変換ツールを使用して、サンプルAPIレスポンスから型定義を生成できます。`)
};

/**
* | output |
* | --- |
* | "API responses often come minified (no whitespace) to save bandwidth. To read them, paste the response into PureJSON's <a href=\"/\">JSON Viewer</a> to get a fo..." |
*
* @param {Guide_Json_Rest_Api_S4_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_s4_p1 = /** @type {((inputs?: Guide_Json_Rest_Api_S4_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_S4_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_s4_p1(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_s4_p1(inputs)
	return ja_guide_json_rest_api_s4_p1(inputs)
});